// src/utils/withFiles.js
// لو فيه ملف مختار → FormData (والـ arrays/objects بتتبعت JSON string).
// لو مفيش ملف → الـ payload زي ما هو (JSON عادي).
export function withFiles(payload, files = {}) {
  const hasFile = Object.values(files).some((f) => f instanceof File);
  if (!hasFile) return payload;

  const fd = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    fd.append(
      key,
      typeof value === "object" ? JSON.stringify(value) : value
    );
  });
  Object.entries(files).forEach(([key, f]) => {
    if (f instanceof File) fd.append(key, f);
  });
  return fd;
}
